import { Participant, Schedule, TimeSchedule } from "../Schedule";
import { Schema } from "../Schema";

export enum SurveyLinkStatus {
  Active = 1,
  Inactive = 3,
}

export interface SurveyLink {
  id: number;
  schemaId: number;
  schema: Schema;
  scheduleId: number;
  schedule: Schedule;
  participantId: number;
  participant: Participant;
  results: Array<{ id: number; linkPath: string }>;
  timeScheduleId: number;
  timeSchedule: TimeSchedule;
  hashPath: string;
  aliasPath: string;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  status: SurveyLinkStatus;
}

export type SurveyLinkListRequest = {
  page?: number;
  limit?: number;
  scheduleId?: number;
  schemaId?: number;
  timeScheduleId?: number;
  participantId?: number;
};

export interface SurveyLinkListResponse extends RestAPIMetaResponse {
  items: Array<SurveyLink>;
}
